import React from "react";
import SubHeading from "../common/SubHeading";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const yesNoOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

const SleepProfileSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <section>
      <SubHeading>Sleep Profile</SubHeading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field
          path="sleepProfile.bedWakeTime"
          label="What time do you go to bed and wake up?"
          type="text"
          placeholder="e.g., 10pm bed, 6am wake"
        />
        <Field
          path="sleepProfile.wakeInNight"
          label="Do you wake in the night?"
          type="text"
          placeholder="e.g., Yes, 2-3 times"
        />
        <Field
          path="sleepProfile.wakeFeelingRested"
          label="Do you wake up feeling rested?"
          type="radio"
          options={yesNoOptions}
        />
        <Field
          path="sleepProfile.mouthBreathe"
          label="Do you mouth breathe?"
          type="radio"
          options={yesNoOptions}
        />
        <Field
          path="sleepProfile.sleepAids"
          label="Do you use sleep aids? If so what kind:"
          type="text"
          placeholder="e.g., Melatonin, white noise"
        />
        <Field
          path="sleepProfile.sleepRetainer"
          label="Do you wear a sleep retainer / guard?"
          type="text"
          placeholder="e.g., Yes, night guard for teeth grinding"
        />
      </div>
      <Field
        path="sleepProfile.sleepDisruptions"
        label="Is there something specific that enhances or disrupts your sleep?"
        type="textarea"
        rows={3}
        placeholder="e.g., Noise, light, stress, etc."
      />
    </section>
  );
};

export default SleepProfileSectionV2;